import { Icon } from '@tcweb/connect-ui';
import { JSXElement } from 'solid-js';

interface IconButtonProps {
  icon: string;
  pressed?: boolean;
  onClick(): void;
  disabled?: boolean;
  color?: 'primary' | 'secondary' | 'tertiary' | 'warning' | 'danger';
}

/**
 *  This component is implemented here, as the existing IconButton
 * does not seem to be able to satisfy the Figma designs. There are also
 * some workarounds in this IconButton due to a Modus styling issue
 * (https://github.com/trimble-oss/modus-wc-2.0/issues/719)
 * TODO: Use IconButton once it's been updated and can be used in this context
 */
export const IconButton = (props: IconButtonProps): JSXElement => {
  return (
    <modus-wc-button
      onClick={() => props.onClick()}
      pressed={props.pressed ?? false}
      color={props.color ?? 'tertiary'}
      size="md"
      attr:custom-class={`w-10 ${props.pressed ? 'bg-gray-4' : ''}`}
      disabled={props.disabled}
    >
      <Icon modusHostClass="!me-0" class="justify-center " icon={props.icon} />
    </modus-wc-button>
  );
};
